import { withStyles } from '@material-ui/styles';
import Switch from '@material-ui/core/Switch';

export default withStyles((theme) => {
  const captionNext = theme.typography.caption;
  return {
    switchBase: {
      width: 61,
      height: 44,
      transform: 'translateX(-8px)'
    },
    bar: {
      height: 16,
      width: 40,
      marginTop: -8,
      borderRadius: 10,
      '&::before': {
        content: '"Off"',
        color: theme.palette.grey['200'],
        fontFamily: captionNext.fontFamily,
        fontSize: 9,
        position: 'absolute',
        top: 3,
        right: 5
      }
    },
    icon: {
      width: 24,
      height: 24
    },
    checked: {
      transform: 'translateX(14px)',
      '& + $bar::before': {
        content: '"On"',
        left: 5
      }
    }
  };
})(Switch);
